import { render, staticRenderFns } from "./base-switch.vue?vue&type=template&id=21d0324f&scoped=true"
import script from "./base-switch.vue?vue&type=script&lang=js"
export * from "./base-switch.vue?vue&type=script&lang=js"
import style0 from "./base-switch.vue?vue&type=style&index=0&id=21d0324f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0324f",
  null
  
)

export default component.exports